import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleSubmit } from "../../../Setup/controller/LockReleaseController/LockReleaseController";
import ModuleService from "../../controller/ModuleController/ModuleController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import HelpSite from "../../../Common/HelpLink";
import LockModuleService from "../../../Setup/controller/LockReleaseController/LockModuleController";
import Swal from 'sweetalert2';
function CreateAgreement() {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ ModuleID: '0' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);
    const [moduleList, setModuleList] = useState([]);
    const [lockRecordList, setlockRecordList] = useState([]);

    const [CustomerLock, setCustomerLock] = useState([]);
    const [AssetLock, setAssetLock] = useState([]);
    const [StockLock, setStockLock] = useState([]);
    const [SupplierLock, setSupplierLock] = useState([]);
    const [QuotationLock, setQuotationLock] = useState([]);
    const [SaleOrderLock, setSaleOrderLock] = useState([]);
    const [PurchaseOrderLock, setPurchaseOrderLock] = useState([]);
    const [AgreementLock, setAgreementLock] = useState([]);
    const [JobsLock, setJobsLock] = useState([]);
    const [ContactLock, setContactLock] = useState([]);

    const [LeadLock, setLeadLock] = useState([]);
    const [OpportunityLock, setOpportunityLock] = useState([]);



    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      };
    const fetchLockRecord = async () => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const listOfLockRecord = await LockModuleService.GetLockModuleRecord(redirectCallback);
            setCustomerLock(listOfLockRecord.CustomerLock);
            setAssetLock(listOfLockRecord.AssetLock);
            setStockLock(listOfLockRecord.StockLock);
            setSupplierLock(listOfLockRecord.SupplierLock);
            setQuotationLock(listOfLockRecord.QuotationLock);
            setSaleOrderLock(listOfLockRecord.SaleOrderLock);
            setPurchaseOrderLock(listOfLockRecord.PurchaseOrderLock);
            setAgreementLock(listOfLockRecord.AgreementLock);
            setJobsLock(listOfLockRecord.JobsLock);
            setContactLock(listOfLockRecord.ContactLock);
            setLeadLock(listOfLockRecord.LeadLock);
            setOpportunityLock(listOfLockRecord.OpportunityLock);
            setlockRecordList(listOfLockRecord || []);
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };
    useEffect(() => {
        fetchLockRecord();
    }, []);

    const handleFieldChange = async (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
        if (name === 'ModuleID') {
            await fetchLockRecord(value);
        }
    };

    const handleFormSubmit = async (event) => {
        debugger;
        event.preventDefault();
        const redirectCallback = () => {
            navigate('/');
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        const postData = await handleSubmit(formData, setFormData, setErrors, redirectCallback, redirectUserList);

        if (postData.message === "data added successfully") {
            Swal.fire(
                'Success!',
                'Data unlocked successfully.',
                'success'
            );
        }

    };
    const handleUnLockClick = async (ID, ModuleID) => {

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, unlock it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const redirectCallback = () => {
                        navigate('/'); // Redirect to the login page
                    };
                    await LockModuleService.GetLockReleaseID(redirectCallback, ModuleID, ID);
                    await fetchLockRecord();


                    Swal.fire(
                        'Unlocked!',
                        'Your record has been unlocked.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });




    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-12" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Agreement Setting" Module="26" />
                </div>
            </div>
            <form onSubmit={handleFormSubmit}>


                {(CustomerLock.length > 0 &&
                    <>
                        <div className="main-content-header">
                            <div className="row mb-3">
                                <div className="col-xl-2">
                                    <h1>Customer</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                            <table className="table m-0 table-hover">
                                <thead>
                                    <tr>
                                        <th>Company Name</th>
                                        <th>Account</th>
                                        <th>Lock By</th>
                                        <th style={{ "textAlign": "right" }}>Unlock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {CustomerLock.map((record) => (
                                        <tr key={record.ClientCompanyID}>
                                            <td>{record.CompanyName}</td>
                                            <td>{record.AccountRef}</td>
                                            <td>{record.LockBy}</td>
                                            <td style={{ "textAlign": "right" }}>

                                                <button type='button' className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleUnLockClick(record.ClientCompanyID, record.ModuleID)}>
                                                    <img style={{ "width": "25px", height: "25px" }} src='assets/img/resources/unlock.png' ></img>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {(AssetLock.length > 0 &&
                    <>
                        <div className="main-content-header">
                            <div className="row mb-3">
                                <div className="col-xl-2">
                                    <h1>Asset</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                            <table className="table m-0 table-hover">
                                <thead>
                                    <tr>
                                        <th>Asset Code</th>
                                        <th>Asset Name</th>
                                        <th>Description</th>
                                        <th>Lock By</th>
                                        <th style={{ "textAlign": "right" }}>Unlock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {AssetLock.map((asset) => (
                                        <tr key={asset.PK_Assets_ID}>
                                            <td>{asset.vc_AssetCode}</td>
                                            <td>{asset.vc_AssetName}</td>
                                            <td>{asset.vc_Description}</td>
                                            <td>{asset.LockBy}</td>
                                            <td style={{ "textAlign": "right" }}>

                                                <button type='button' className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleUnLockClick(asset.PK_Assets_ID, asset.ModuleID)}>
                                                    <img style={{ "width": "25px", height: "25px" }} src='assets/img/resources/unlock.png' ></img>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {(StockLock.length > 0 &&
                    <>
                        <div className="main-content-header">
                            <div className="row mb-3">
                                <div className="col-xl-2">
                                    <h1>Part</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                            <table className="table m-0 table-hover">
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Description</th>

                                        <th>Lock By</th>
                                        <th style={{ "textAlign": "right" }}>Unlock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {StockLock.map((stock) => (
                                        <tr key={stock.PK_Stock_ID}>
                                            <td>{stock.vc_StockCode}</td>
                                            <td>{stock.vc_StockName}</td>

                                            <td>{stock.LockBy}</td>
                                            <td style={{ "textAlign": "right" }}>

                                                <button type='button' className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleUnLockClick(stock.PK_Stock_ID, stock.ModuleID)}>
                                                    <img style={{ "width": "25px", height: "25px" }} src='assets/img/resources/unlock.png' ></img>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {(SupplierLock.length > 0 &&
                    <>
                        <div className="main-content-header">
                            <div className="row mb-3">
                                <div className="col-xl-12">
                                    <h1>Supplier</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                            <table className="table m-0 table-hover">
                                <thead>
                                    <tr>
                                        <th>Supplier</th>
                                        <th>Account</th>
                                        <th>Address</th>
                                        <th>Lock By</th>
                                        <th style={{ "textAlign": "right" }}>Unlock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {SupplierLock.map((supplier) => (
                                        <tr key={supplier.PK_Supplier_ID}>
                                            <td>{supplier.vc_SupplierName}</td>
                                            <td>{supplier.vc_AccountRef}</td>
                                            <td>{supplier.vc_Address1}</td>
                                            <td>{supplier.LockBy}</td>
                                            <td style={{ "textAlign": "right" }}>

                                                <button type='button' className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleUnLockClick(supplier.PK_Supplier_ID, supplier.ModuleID)}>
                                                    <img style={{ "width": "25px", height: "25px" }} src='assets/img/resources/unlock.png' ></img>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {(QuotationLock.length > 0 &&
                    <>
                        <div className="main-content-header">
                            <div className="row mb-3">
                                <div className="col-xl-12">
                                    <h1>Quotation</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                            <table className="table m-0 table-hover">
                                <thead>
                                    <tr>
                                        <th>Quotation No.</th>
                                        <th>Lock By</th>
                                        <th style={{ "textAlign": "right" }}>Unlock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {QuotationLock.map((quotation) => (
                                        <tr key={quotation.PK_Quotation_ID}>
                                            <td>{quotation.bnt_OrderNumber}</td>

                                            <td>{quotation.LockBy}</td>
                                            <td style={{ "textAlign": "right" }}>

                                                <button type='button' className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleUnLockClick(quotation.PK_Quotation_ID, quotation.ModuleID)}>
                                                    <img style={{ "width": "25px", height: "25px" }} src='assets/img/resources/unlock.png' ></img>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {(SaleOrderLock.length > 0 &&
                    <>
                        <div className="main-content-header">
                            <div className="row mb-3">
                                <div className="col-xl-12">
                                    <h1>Sale Order</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                            <table className="table m-0 table-hover">
                                <thead>
                                    <tr>
                                        <th>Sale Order No.</th>
                                        <th>Lock By</th>
                                        <th style={{ "textAlign": "right" }}>Unlock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {SaleOrderLock.map((sale) => (
                                        <tr key={sale.PK_SalesOrder_ID}>
                                            <td>{sale.bnt_OrderNumber}</td>

                                            <td>{sale.LockBy}</td>
                                            <td style={{ "textAlign": "right" }}>

                                                <button type='button' className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleUnLockClick(sale.PK_SalesOrder_ID, sale.ModuleID)}>
                                                    <img style={{ "width": "25px", height: "25px" }} src='assets/img/resources/unlock.png' ></img>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {(PurchaseOrderLock.length > 0 &&
                    <>
                        <div className="main-content-header">
                            <div className="row mb-3">
                                <div className="col-xl-12">
                                    <h1>Purchase Order</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                            <table className="table m-0 table-hover">
                                <thead>
                                    <tr>
                                        <th>Purchase Order No.</th>
                                        <th>Lock By</th>
                                        <th style={{ "textAlign": "right" }}>Unlock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {PurchaseOrderLock.map((sale) => (
                                        <tr key={sale.PK_PurchaseOrder_ID}>
                                            <td>{sale.bnt_OrderNumber}</td>

                                            <td>{sale.LockBy}</td>
                                            <td style={{ "textAlign": "right" }}>

                                                <button type='button' className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleUnLockClick(sale.PK_PurchaseOrder_ID, sale.ModuleID)}>
                                                    <img style={{ "width": "25px", height: "25px" }} src='assets/img/resources/unlock.png' ></img>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {(AgreementLock.length > 0 &&
                    <>
                        <div className="main-content-header">
                            <div className="row mb-3">
                                <div className="col-xl-12">
                                    <h1>Agreement</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                            <table className="table m-0 table-hover">
                                <thead>
                                    <tr>
                                        <th>Reference</th>
                                        <th>Start Date</th>
                                        <th>Lock By</th>
                                        <th style={{ "textAlign": "right" }}>Unlock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {AgreementLock.map((sale) => (
                                        <tr key={sale.ContractID}>
                                            <td>{sale.contractNumber}</td>
                                            <td>{formatDate(sale.contractStartDate)}</td>
                                            <td>{sale.LockBy}</td>
                                            <td style={{ "textAlign": "right" }}>

                                                <button type='button' className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleUnLockClick(sale.ContractID, sale.ModuleID)}>
                                                    <img style={{ "width": "25px", height: "25px" }} src='assets/img/resources/unlock.png' ></img>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {(JobsLock.length > 0 &&
                    <>
                        <div className="main-content-header">
                            <div className="row mb-3">
                                <div className="col-xl-12">
                                    <h1>Jobs</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                            <table className="table m-0 table-hover">
                                <thead>
                                    <tr>
                                        <th>Job No.</th>
                                        <th>Description</th>
                                        <th>Lock By</th>
                                        <th style={{ "textAlign": "right" }}>Unlock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {JobsLock.map((sale) => (
                                        <tr key={sale.IssueID}>
                                            <td>{sale.bnt_OrderNumber}</td>
                                            <td>{sale.IssueTitle}</td>
                                            <td>{sale.LockBy}</td>
                                            <td style={{ "textAlign": "right" }}>

                                                <button type='button' className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleUnLockClick(sale.IssueID, sale.ModuleID)}>
                                                    <img style={{ "width": "25px", height: "25px" }} src='assets/img/resources/unlock.png' ></img>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                 {(ContactLock.length > 0 &&
                    <>
                        <div className="main-content-header">
                            <div className="row mb-3">
                                <div className="col-xl-12">
                                    <h1>Contacts</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                            <table className="table m-0 table-hover">
                                <thead>
                                    <tr>
                                        <th>Contact Name.</th>
                                        <th>Email</th>
                                        <th>Lock By</th>
                                        <th style={{ "textAlign": "right" }}>Unlock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ContactLock.map((sale) => (
                                        <tr key={sale.ClientContactID}>
                                            <td>{sale.Name}</td>
                                            <td>{sale.Email}</td>
                                            <td>{sale.LockBy}</td>
                                            <td style={{ "textAlign": "right" }}>

                                                <button type='button' className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleUnLockClick(sale.ClientContactID, sale.ModuleID)}>
                                                    <img style={{ "width": "25px", height: "25px" }} src='assets/img/resources/unlock.png' ></img>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {(LeadLock.length > 0 &&
                    <>
                        <div className="main-content-header">
                            <div className="row mb-3">
                                <div className="col-xl-12">
                                    <h1>Lead</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                            <table className="table m-0 table-hover">
                                <thead>
                                    <tr>
                                        <th>Company Name.</th>
                                        <th>Contact</th>
                                        <th>Lock By</th>
                                        <th style={{ "textAlign": "right" }}>Unlock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {LeadLock.map((sale) => (
                                        <tr key={sale.ID}>
                                            <td>{sale.vc_Company}</td>
                                            <td>{sale.Name}</td>
                                            <td>{sale.LockBy}</td>
                                            <td style={{ "textAlign": "right" }}>

                                                <button type='button' className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleUnLockClick(sale.ID, sale.ModuleID)}>
                                                    <img style={{ "width": "25px", height: "25px" }} src='assets/img/resources/unlock.png' ></img>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {(OpportunityLock.length > 0 &&
                    <>
                        <div className="main-content-header">
                            <div className="row mb-3">
                                <div className="col-xl-12">
                                    <h1>Opportunity</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                            <table className="table m-0 table-hover">
                                <thead>
                                    <tr>
                                        <th>Company Name.</th>
                                        <th>Contact</th>
                                        <th>Lock By</th>
                                        <th style={{ "textAlign": "right" }}>Unlock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {OpportunityLock.map((sale) => (
                                        <tr key={sale.ID}>
                                            <td>{sale.vc_Company}</td>
                                            <td>{sale.Name}</td>
                                            <td>{sale.LockBy}</td>
                                            <td style={{ "textAlign": "right" }}>

                                                <button type='button' className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleUnLockClick(sale.ID, sale.ModuleID)}>
                                                    <img style={{ "width": "25px", height: "25px" }} src='assets/img/resources/unlock.png' ></img>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}

            </form>
        </div>
    );
}

export default CreateAgreement;
